import { Skeleton } from "antd";
import React from "react";

const SubCollectionTagSkeleton = () => {
  const tags = [...new Array(10)];
    return tags.map((tag, index) => {
      const randomWidth = Math.floor(Math.random() * 100) + 50;
    return (
      <Skeleton.Button
        key={index}
        active
        style={{
          width: randomWidth,
          height: "30px",
          margin: "0 10px 10px 0",
        }}
      />
    );
  });
};

export default SubCollectionTagSkeleton;
